<template>
  <div class="system-settings-page">
    <el-card class="settings-card" shadow="never">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="用户管理" name="userManage">
          <div class="user-manage-pane">
            <div class="user-search-area">
              <el-form :inline="true" :model="userSearchForm" class="search-form">
                <el-form-item label="用户名">
                  <el-input v-model="userSearchForm.username" placeholder="请输入用户名" clearable />
                </el-form-item>
                <el-form-item label="手机号">
                  <el-input v-model="userSearchForm.phone" placeholder="请输入手机号" clearable />
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="userSearchForm.statusCode" placeholder="请选择" clearable>
                    <el-option label="正常" value="ACTIVE" />
                    <el-option label="禁用" value="DISABLED" />
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="btn-group">
                <el-button type="primary" icon="el-icon-search" size="small" @click="handleUserSearch">查询</el-button>
                <el-button icon="el-icon-refresh" size="small" @click="handleUserSearchReset">重置</el-button>
                <el-button icon="el-icon-plus" size="small" @click="handleUserAdd">添加用户</el-button>
              </div>
            </div>
            <el-table :data="userList" v-loading="userListLoading" border stripe>
              <el-table-column type="index" label="序号" width="60" :index="userIndexMethod" />
              <el-table-column prop="nickname" label="用户名" min-width="120" />
              <el-table-column prop="phone" label="手机号" width="130" />
              <el-table-column prop="role" label="角色" width="120">
                <template slot-scope="{ row }">
                  <el-tag v-if="row.role" size="small">{{ roleLabel(row.role) }}</el-tag>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="statusCode" label="状态" width="100">
                <template slot-scope="{ row }">
                  <el-tag :type="row.statusCode === 'ACTIVE' ? 'success' : 'danger'" size="small">{{ row.statusCode === 'ACTIVE' ? '正常' : '禁用' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createdAt" label="创建时间" width="170" />
              <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="{ row }">
                  <el-button type="text" size="small" @click="handleUserEdit(row)">编辑</el-button>
                  <el-button v-if="row.nickname !== 'systemManager' && row.role !== 'admin'" type="text" size="small" class="danger-btn" @click="handleUserDelete(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-wrapper">
              <el-pagination
                class="pagination"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="userTotal"
                :page-size="userPageSize"
                :current-page="userCurrentPage"
                :page-sizes="[10, 20, 50, 100]"
                @size-change="handleUserSizeChange"
                @current-change="handleUserCurrentChange"
              />
            </div>
            <el-dialog :title="userDialogTitle" :visible.sync="userDialogVisible" width="1000px" class="user-dialog" :close-on-click-modal="false" @close="resetUserForm">
              <el-form ref="userForm" :model="userForm" :rules="userFormRules" label-width="100px" class="user-form">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用户名" prop="nickname">
                      <el-input v-model="userForm.nickname" placeholder="请输入用户名" maxlength="100" show-word-limit clearable class="user-form-input" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="手机号" prop="phone">
                      <el-input v-model="userForm.phone" placeholder="请输入手机号" maxlength="20" clearable class="user-form-input" :disabled="isUserEdit" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="密码" prop="password">
                      <el-input v-model="userForm.password" type="password" :placeholder="isUserEdit ? '不修改请留空' : '请输入密码'" maxlength="50" show-password clearable class="user-form-input" />
                    </el-form-item>
                    <div class="password-strength">
                      <span class="strength-label">密码强度：</span>
                      <el-rate
                        :value="passwordStrength"
                        disabled
                        :max="5"
                        show-text
                        :texts="['弱', '一般', '中等', '较强', '非常强']"
                        :colors="['#00FF00', '#00FF00', '#00FF00']"
                      />
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="确认密码" prop="confirmPassword">
                      <el-input v-model="userForm.confirmPassword" type="password" :placeholder="isUserEdit ? '不修改请留空' : '请再次输入密码'" maxlength="50" show-password clearable class="user-form-input" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="角色" prop="role">
                      <el-select v-model="userForm.role" placeholder="请选择角色" class="user-form-input" :loading="roleOptionsLoading">
                        <el-option v-for="r in roleOptions" :key="r.roleId" :label="r.roleName" :value="r.roleCode" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="状态" prop="statusCode">
                      <el-select v-model="userForm.statusCode" placeholder="请选择状态" class="user-form-input">
                        <el-option label="正常" value="ACTIVE" />
                        <el-option label="禁用" value="DISABLED" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="userDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleUserSave" :loading="userSaveLoading">确定</el-button>
              </span>
            </el-dialog>
          </div>
        </el-tab-pane>
        <el-tab-pane label="角色管理" name="roleManage">
          <div v-if="tabPaneReady.roleManage" class="role-manage-pane">
            <RoleManage />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="canMenuDict" label="字典管理" name="dictManage">
          <div v-if="tabPaneReady.dictManage" class="dict-manage-pane">
            <DictManage />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="canMenuLog" label="日志管理" name="logManage">
          <div v-if="tabPaneReady.logManage" class="log-manage-pane">
            <LogManage />
          </div>
        </el-tab-pane>
        <el-tab-pane label="业务参数配置" name="businessParamsConfig">
          <div v-if="tabPaneReady.businessParamsConfig" class="business-params-config-pane">
            <BusinessParamsConfig />
          </div>
        </el-tab-pane>
        <el-tab-pane label="模板管理" name="templateManage">
          <div v-if="tabPaneReady.templateManage" class="template-manage-pane">
            <TemplateManage />
          </div>
        </el-tab-pane>
        <el-tab-pane label="电子地图配置" name="electronicMap">
          <div v-if="tabPaneReady.electronicMap" class="electronic-map-config">
            <el-form ref="form" :model="form" label-width="160px" size="medium">
              <el-form-item label="路线颜色">
                <el-color-picker v-model="form.routeColor" show-alpha :predefine="predefineColors" />
                <span class="color-value">{{ form.routeColor }}</span>
              </el-form-item>
              <el-form-item label="路线宽度">
                <el-input-number v-model="form.routeWidth" :min="1" :max="20" :step="1" controls-position="right" style="width: 200px;" />
                <span class="form-tip">1-20，默认 6</span>
              </el-form-item>
              <el-form-item label="路线透明度">
                <el-slider v-model="form.routeBaseAlpha" :min="0" :max="1" :step="0.05" show-input />
                <span class="form-tip">0-1，默认 0.24</span>
              </el-form-item>
              <el-collapse v-model="activeCollapse">
                <el-collapse-item title="小车轨迹 - 线条样式" name="trajectoryLine">
                  <el-form-item label="已通过路线颜色">
                    <el-color-picker v-model="form.passedRouteColor" :predefine="predefineColors" />
                    <span class="color-value">{{ form.passedRouteColor }}</span>
                  </el-form-item>
                  <el-form-item label="未通过路线颜色">
                    <el-color-picker v-model="form.notPassedRouteColor" :predefine="predefineColors" />
                    <span class="color-value">{{ form.notPassedRouteColor }}</span>
                  </el-form-item>
                  <el-form-item label="轨迹线宽度">
                    <el-input-number v-model="form.trajectoryLineWeight" :min="1" :max="20" :step="1" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">1-20，默认 6</span>
                  </el-form-item>
                  <el-form-item label="轨迹线透明度">
                    <el-slider v-model="form.trajectoryLineOpacity" :min="0" :max="1" :step="0.05" show-input />
                    <span class="form-tip">0-1，默认 0.9</span>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="小车轨迹 - 动画" name="trajectoryAnim">
                  <el-form-item label="小车速度">
                    <el-input-number v-model="form.carSpeed" :min="0" :max="9999" :step="50" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">0-9999，默认 500</span>
                  </el-form-item>
                  <el-form-item label="动画刷新间隔(ms)">
                    <el-input-number v-model="form.interval" :min="10" :max="500" :step="5" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">10-500ms，默认 25</span>
                  </el-form-item>
                  <el-form-item label="显示历史轨迹">
                    <el-radio-group v-model="form.showHistoryTrack">
                      <el-radio label="1">显示</el-radio>
                      <el-radio label="0">不显示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="循环播放">
                    <el-switch v-model="form.loopPlay" active-text="循环" inactive-text="不循环" />
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="小车轨迹 - 图标" name="trajectoryIcon">
                  <el-form-item label="图标尺寸">
                    <el-input-number v-model="form.carIconSize" :min="16" :max="64" :step="2" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">16-64px，默认 28</span>
                  </el-form-item>
                  <el-form-item label="图标字符">
                    <el-input v-model="form.carEmoji" placeholder="如：🚗" maxlength="4" clearable style="width: 120px;" />
                    <span class="form-tip">emoji 或文字，默认 🚗</span>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="小车轨迹 - 提示" name="trajectoryTooltip">
                  <el-form-item label="显示路线提示">
                    <el-switch v-model="form.showTooltip" active-text="显示" inactive-text="不显示" />
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="其他（箭头等）" name="other">
                  <el-form-item label="展示箭头">
                    <el-switch v-model="form.showArrow" active-text="展示" inactive-text="不展示" />
                  </el-form-item>
                  <el-form-item label="offset">
                    <el-input-number v-model="form.offset" :min="0" :max="100" :step="1" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">0-100</span>
                  </el-form-item>
                  <el-form-item label="repeat">
                    <el-input-number v-model="form.repeat" :min="0" :max="100" :step="1" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">0-100</span>
                  </el-form-item>
                  <el-form-item label="pixelSize">
                    <el-input-number v-model="form.pixelSize" :min="0" :max="10" :step="1" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">0-10</span>
                  </el-form-item>
                  <el-form-item label="headAngle">
                    <el-input-number v-model="form.headAngle" :min="0" :max="100" :step="1" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">0-100</span>
                  </el-form-item>
                  <el-form-item label="箭头颜色">
                    <el-color-picker v-model="form.arrowColor" :predefine="predefineColors" />
                    <span class="color-value">{{ form.arrowColor }}</span>
                  </el-form-item>
                  <el-form-item label="weight">
                    <el-input-number v-model="form.weight" :min="0" :max="10" :step="1" controls-position="right" style="width: 200px;" />
                    <span class="form-tip">0-10</span>
                  </el-form-item>
                </el-collapse-item>
              </el-collapse>
              <el-form-item class="form-actions">
                <el-button type="primary" @click="handleSave" :loading="saveLoading">保存配置</el-button>
                <el-button @click="handleReset">恢复默认</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="管理员工具" name="adminTools">
          <div v-if="tabPaneReady.adminTools" class="admin-tools-config">
            <el-form :model="adminForm" label-width="120px" size="medium">
              <div class="admin-tools-section-title admin-tools-section-title--first">平台管理</div>
              <el-form-item label="系统标题">
                <el-input
                  v-model="adminForm.systemTitle"
                  placeholder="请输入系统标题"
                  clearable
                  style="width: 360px;"
                />
              </el-form-item>
              <el-form-item label="系统标题（短）">
                <el-input
                  v-model="adminForm.systemTitleShort"
                  placeholder="侧边栏收起时显示，如：学途无忧网"
                  clearable
                  style="width: 360px;"
                />
              </el-form-item>
              <el-form-item label="平台logo">
                <div class="logo-upload-wrap">
                  <div class="logo-preview">
                    <img :src="adminForm.platformLogo" alt="平台logo" class="logo-img" />
                  </div>
                  <div class="logo-actions">
                    <el-upload
                      :show-file-list="false"
                      :before-upload="beforeLogoUpload"
                      accept="image/png,image/jpeg,image/jpg,image/gif"
                      action="#"
                    >
                      <el-button size="small" type="primary">上传图片</el-button>
                    </el-upload>
                    <el-button size="small" @click="handleRestoreDefaultLogo">恢复默认</el-button>
                  </div>
                </div>
              </el-form-item>
              <div class="admin-tools-section-title">发布公告</div>
              <el-form-item label="公告内容">
                <el-input
                  v-model="adminForm.announcement"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入公告内容（将保存到本地系统配置）"
                  maxlength="200"
                  show-word-limit
                  style="width: 720px; max-width: 100%;"
                />
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="字体颜色">
                    <el-color-picker
                      v-model="adminForm.announcementColor"
                      show-alpha
                      :predefine="announcementPredefineColors"
                    />
                    <span class="color-value">{{ adminForm.announcementColor }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="字体大小">
                    <div class="announcement-font-size-input">
                      <el-input-number
                        v-model="adminForm.announcementFontSize"
                        :min="10"
                        :max="50"
                        :step="1"
                        controls-position="right"
                        style="width: 200px;"
                      />
                      <span class="announcement-font-size-unit">px</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="滚动速度">
                    <div class="announcement-scroll-speed-input">
                      <el-input-number
                        v-model="adminForm.announcementScrollSpeed"
                        :min="10"
                        :max="50"
                        :step="1"
                        controls-position="right"
                        style="width: 200px;"
                      />
                      <span class="announcement-scroll-speed-unit">s</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否滚动">
                    <el-switch
                      v-model="adminForm.announcementScroll"
                      active-text="滚动"
                      inactive-text="不滚动"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="是否发布">
                <el-switch
                  v-model="adminForm.announcementPublished"
                  active-text="发布"
                  inactive-text="不发布"
                />
              </el-form-item>
              <el-form-item label="谁可以看">
                <el-checkbox-group v-model="adminForm.announcementViewerRoles">
                  <el-checkbox
                    v-for="r in roleOptions"
                    :key="r.roleCode"
                    :label="r.roleCode"
                  >
                    {{ r.roleName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <div class="admin-tools-section-title">水印管理</div>
              <el-form-item label="启用水印">
                <el-switch
                  v-model="adminForm.watermarkEnabled"
                  active-text="启用"
                  inactive-text="禁用"
                />
              </el-form-item>
              <el-form-item label="水印内容模板">
                <el-input
                  v-model="adminForm.watermarkContentTemplate"
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="支持：{username}（用户名）{ip}（客户端IP）{date}（日期YYYYMMDD）"
                  style="width: 720px; max-width: 100%;"
                />
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="文字大小">
                    <div class="watermark-font-size-input">
                      <el-input-number
                        v-model="adminForm.watermarkFontSize"
                        :min="10"
                        :max="50"
                        :step="1"
                        controls-position="right"
                        style="width: 200px;"
                      />
                      <span class="watermark-unit">px</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="文字颜色">
                    <el-color-picker
                      v-model="adminForm.watermarkFontColor"
                      show-alpha
                      :predefine="watermarkPredefineColors"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="倾斜角度">
                    <el-input-number
                      v-model="adminForm.watermarkRotate"
                      :min="-180"
                      :max="180"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="透明度">
                    <el-input-number
                      v-model="adminForm.watermarkGlobalAlpha"
                      :min="0"
                      :max="1"
                      :step="0.01"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="间距X">
                    <el-input-number
                      v-model="adminForm.watermarkGapX"
                      :min="0"
                      :max="200"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="间距Y">
                    <el-input-number
                      v-model="adminForm.watermarkGapY"
                      :min="0"
                      :max="200"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="宽">
                    <el-input-number
                      v-model="adminForm.watermarkWidth"
                      :min="100"
                      :max="600"
                      :step="10"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="高">
                    <el-input-number
                      v-model="adminForm.watermarkHeight"
                      :min="100"
                      :max="600"
                      :step="10"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="平移X">
                    <el-input-number
                      v-model="adminForm.watermarkTranslateX"
                      :min="-200"
                      :max="200"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="平移Y">
                    <el-input-number
                      v-model="adminForm.watermarkTranslateY"
                      :min="-200"
                      :max="200"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="网格行">
                    <el-input-number
                      v-model="adminForm.watermarkGridRows"
                      :min="1"
                      :max="6"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="网格列">
                    <el-input-number
                      v-model="adminForm.watermarkGridCols"
                      :min="1"
                      :max="6"
                      :step="1"
                      controls-position="right"
                      style="width: 200px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="布局类型">
                    <el-select
                      v-model="adminForm.watermarkLayoutType"
                      placeholder="请选择"
                      clearable
                      style="width: 200px;"
                    >
                      <el-option label="grid" value="grid" />
                      <el-option label="default" value="default" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="handleSaveAdmin" :loading="adminSaveLoading">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="定时任务管理" name="scheduledTaskManage">
          <div v-if="tabPaneReady.scheduledTaskManage" class="scheduled-task-manage-pane">
            <ScheduledTaskManage />
          </div>
        </el-tab-pane>
        <el-tab-pane label="预警配置" name="alertConfig">
          <div v-if="tabPaneReady.alertConfig" class="alert-config-pane">
            <p class="placeholder-tip">预警配置功能开发中，敬请期待。</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="推广落地页管理" name="landingPageManage">
          <div v-if="tabPaneReady.landingPageManage" class="landing-page-manage-pane">
            <el-form
              ref="landingPageForm"
              :model="landingPageForm"
              :rules="landingPageRules"
              label-width="120px"
              size="medium"
              class="landing-page-form"
            >
              <el-form-item label="终端类型" prop="terminalType">
                <el-select
                  v-model="landingPageForm.terminalType"
                  placeholder="请选择终端类型"
                  style="width: 360px;"
                  clearable
                >
                  <el-option
                    v-for="item in landingPageTerminalOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="上传物料" prop="materialFile">
                <el-upload
                  ref="landingPageUpload"
                  action="#"
                  accept=".zip,application/zip,application/x-zip-compressed"
                  :auto-upload="false"
                  :limit="1"
                  :file-list="landingPageFileList"
                  :on-change="handleLandingPageFileChange"
                  :on-remove="handleLandingPageFileRemove"
                  :on-exceed="handleLandingPageFileExceed"
                >
                  <el-button size="small" type="primary" icon="el-icon-upload2">选择 zip 文件</el-button>
                  <div slot="tip" class="el-upload__tip">请上传 zip 文件，提交后将解压到所选终端对应目录。</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-upload"
                  :loading="landingPageUploadLoading"
                  @click="handleLandingPageUpload"
                >
                  确认上传
                </el-button>
                <el-button @click="resetLandingPageForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="数据库备份" name="databaseBackup">
          <div v-if="tabPaneReady.databaseBackup" class="database-backup-pane">
            <el-form label-width="120px" size="medium" class="database-backup-form">
              <el-form-item label="默认备份目录">
                <el-input
                  :value="databaseBackupDefaultPath"
                  readonly
                  class="database-backup-path"
                />
              </el-form-item>
              <el-form-item label="备份文件">
                <div class="database-backup-actions">
                  <el-button
                    type="primary"
                    icon="el-icon-download"
                    :loading="databaseBackupLoading"
                    @click="handleDatabaseBackup"
                  >
                    数据备份到本地
                  </el-button>
                  <span v-if="databaseBackupLastFileName" class="database-backup-file">{{ databaseBackupLastFileName }}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="databaseBackupLoading" label="备份进度">
                <div class="database-backup-progress">
                  <el-progress :percentage="databaseBackupProgress" :stroke-width="12" />
                  <span class="database-backup-status">{{ databaseBackupStatus }}</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="关于" name="about">
          <div v-if="tabPaneReady.about" class="about-pane">
            <p class="version-text">当前系统版本：<strong>SL:V26.1.0</strong></p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import api from '@/services/api';
import { getElectronicMapSettings, saveElectronicMapSettings, DEFAULTS } from '@/utils/electronicMapSettings';
import { getSystemConfig, saveSystemConfig, DEFAULTS as SYS_DEFAULTS, DEFAULT_LOGO_URL } from '@/utils/systemConfig';
import RoleManage from './RoleManage.vue';
import DictManage from './DictManage.vue';
import LogManage from './LogManage.vue';
import BusinessParamsConfig from './BusinessParamsConfig.vue';
import TemplateManage from './TemplateManage.vue';
import ScheduledTaskManage from './ScheduledTaskManage.vue';
import { getAllowedMenus } from '@/utils/sessionAuth';
import { isMenuKeyAllowed } from '@/utils/menuPermissions';

export default {
  name: 'SystemSettings',
  components: {
    RoleManage,
    DictManage,
    LogManage,
    BusinessParamsConfig,
    TemplateManage,
    ScheduledTaskManage
  },
  data() {
    return {
      activeTab: 'userManage',
      /** 仅已访问过的 Tab 才挂载内容，避免进入「系统设置」时并发请求所有子页面接口 */
      tabPaneReady: {},
      _didLoadElectronicMapLocalSettings: false,
      _didLoadAdminToolsRemote: false,
      userList: [],
      userListLoading: false,
      userTotal: 0,
      userCurrentPage: 1,
      userPageSize: 10,
      userSearchForm: {
        username: '',
        phone: '',
        statusCode: ''
      },
      userDialogVisible: false,
      userSaveLoading: false,
      editUserId: null,
      userForm: {
        nickname: '',
        phone: '',
        password: '',
        confirmPassword: '',
        role: '',
        statusCode: 'ACTIVE'
      },
      roleOptions: [],
      roleOptionsLoading: false,
      userFormRules: {
        nickname: [
          { required: true, message: '请输入用户名', trigger: ['blur', 'change'] },
          { max: 100, message: '最多100字符', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: ['change', 'blur'] }
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (!this.isUserEdit && !value) {
                return callback(new Error('请输入密码'));
              }
              if (!value) return callback();
              if (value.length < 6 || value.length > 50) {
                return callback(new Error('密码长度6-50位'));
              }
              const hasLetter = /[a-zA-Z]/.test(value);
              const hasNumber = /\d/.test(value);
              const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(value);
              const typeCount = [hasLetter, hasNumber, hasSpecial].filter(Boolean).length;
              if (typeCount < 2) {
                callback(new Error('密码至少由字母、数字、特殊符号中的两种组成'));
              } else {
                if (this.userForm.confirmPassword) {
                  this.$refs.userForm.validateField('confirmPassword');
                }
                callback();
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        confirmPassword: [
          {
            validator: (rule, value, callback) => {
              if (!this.isUserEdit && !value) {
                return callback(new Error('请确认密码'));
              }
              if (this.userForm.password && !value) {
                return callback(new Error('请确认密码'));
              }
              if (!value) return callback();
              if (value !== this.userForm.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: ['blur', 'change'] }
        ]
      },
      adminForm: {
        systemTitle: SYS_DEFAULTS.systemTitle,
        systemTitleShort: SYS_DEFAULTS.systemTitleShort,
        platformLogo: SYS_DEFAULTS.platformLogo,
        announcement: '',
        announcementColor: 'rgba(255,140,0,1)',
        announcementFontSize: 22,
        announcementScrollSpeed: 26,
        announcementScroll: true,
        announcementPublished: false,
        announcementViewerRoles: null,
        // ===== 水印管理（后端单例配置）=====
        watermarkEnabled: true,
        watermarkContentTemplate: '{username} {ip} {date}',
        watermarkFontSize: 20,
        watermarkFontColor: 'rgba(0,0,0,0.2)',
        watermarkRotate: -20,
        watermarkGlobalAlpha: 0.2,
        watermarkWidth: 300,
        watermarkHeight: 300,
        watermarkLayoutType: 'grid',
        watermarkGridRows: 2,
        watermarkGridCols: 2,
        watermarkGapX: 20,
        watermarkGapY: 20,
        watermarkTranslateX: 0,
        watermarkTranslateY: 0
      },
      adminSaveLoading: false,
      landingPageForm: {
        terminalType: '',
        materialFile: null
      },
      landingPageFileList: [],
      landingPageUploadLoading: false,
      databaseBackupLoading: false,
      databaseBackupProgress: 0,
      databaseBackupStatus: '',
      databaseBackupDefaultPath: 'D:\\1、localRepository\\6、mysql_DB_beifen',
      databaseBackupLastFileName: '',
      landingPageTerminalOptions: [
        { label: 'PC端（/opt/baidu/pc）', value: 'pc' },
        { label: '移动端（/opt/baidu/mobile）', value: 'mobile' }
      ],
      landingPageRules: {
        terminalType: [
          { required: true, message: '请选择终端类型', trigger: ['change', 'blur'] }
        ],
        materialFile: [
          {
            validator: (_rule, value, callback) => {
              if (!value) return callback(new Error('请选择要上传的 zip 文件'));
              return callback();
            },
            trigger: ['change', 'blur']
          }
        ]
      },
      announcementPredefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      watermarkPredefineColors: [
        '#000000',
        '#409EFF',
        '#ffffff',
        'rgba(0, 0, 0, 0.2)',
        'rgba(0, 0, 0, 0.15)',
        'rgba(64, 158, 255, 0.2)',
        'rgba(64, 158, 255, 0.15)',
        'rgba(255, 140, 0, 0.2)'
      ],
      activeCollapse: ['trajectoryLine', 'trajectoryAnim'],
      form: {
        routeColor: DEFAULTS.routeColor,
        routeWidth: DEFAULTS.routeWidth,
        routeBaseAlpha: DEFAULTS.routeBaseAlpha,
        passedRouteColor: DEFAULTS.passedRouteColor,
        notPassedRouteColor: DEFAULTS.notPassedRouteColor,
        trajectoryLineWeight: DEFAULTS.trajectoryLineWeight,
        trajectoryLineOpacity: DEFAULTS.trajectoryLineOpacity,
        carSpeed: DEFAULTS.carSpeed,
        interval: DEFAULTS.interval,
        showHistoryTrack: DEFAULTS.showHistoryTrack,
        loopPlay: DEFAULTS.loopPlay,
        carIconSize: DEFAULTS.carIconSize,
        carEmoji: DEFAULTS.carEmoji,
        showTooltip: DEFAULTS.showTooltip,
        showArrow: DEFAULTS.showArrow,
        offset: DEFAULTS.offset,
        repeat: DEFAULTS.repeat,
        pixelSize: DEFAULTS.pixelSize,
        headAngle: DEFAULTS.headAngle,
        arrowColor: DEFAULTS.arrowColor,
        weight: DEFAULTS.weight
      },
      predefineColors: [
        '#ffffff',
        '#0000ff',
        '#ff0000',
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      saveLoading: false
    };
  },
  computed: {
    isUserEdit() {
      return !!this.editUserId;
    },
    userDialogTitle() {
      return this.isUserEdit ? '编辑用户' : '添加用户';
    },
    passwordStrength() {
      const pwd = this.userForm.password || '';
      if (!pwd) return 0;
      let score = 0;
      if (pwd.length >= 6) score++;
      if (pwd.length >= 8) score++;
      if (pwd.length >= 12) score++;
      if (/[a-z]/.test(pwd)) score++;
      if (/[A-Z]/.test(pwd)) score++;
      if (/\d/.test(pwd)) score++;
      if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(pwd)) score++;
      if (score <= 2) return 1;
      if (score <= 3) return 2;
      if (score <= 4) return 3;
      if (score <= 5) return 4;
      return 5;
    },
    canMenuDict() {
      const m = getAllowedMenus();
      return Array.isArray(m) && m.length ? isMenuKeyAllowed('dict', m) : false;
    },
    canMenuLog() {
      const m = getAllowedMenus();
      return Array.isArray(m) && m.length ? isMenuKeyAllowed('log', m) : false;
    }
  },
  watch: {
    '$route.query.tab'() {
      this.applyRouteTab();
    },
    activeTab: {
      handler(name) {
        if (!name) return;
        this.$set(this.tabPaneReady, name, true);
        if (name === 'electronicMap' && !this._didLoadElectronicMapLocalSettings) {
          this._didLoadElectronicMapLocalSettings = true;
          this.loadSettings();
        }
        if (name === 'adminTools' && !this._didLoadAdminToolsRemote) {
          this._didLoadAdminToolsRemote = true;
          this.loadAdminSettings();
          this.loadAnnouncementConfig();
          this.loadWatermarkConfig();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.loadUserList();
    this.loadRoleOptions();
    this.applyRouteTab();
  },
  methods: {
    applyRouteTab() {
      const tab = this.$route.query && String(this.$route.query.tab || '');
      if (tab === 'dictManage' && this.canMenuDict) {
        this.activeTab = 'dictManage';
        return;
      }
      if (tab === 'logManage' && this.canMenuLog) {
        this.activeTab = 'logManage';
      }
    },
    loadSettings() {
      try {
        const s = getElectronicMapSettings();
        this.form = {
          routeColor: s.routeColor,
          routeWidth: s.routeWidth,
          routeBaseAlpha: s.routeBaseAlpha,
          passedRouteColor: s.passedRouteColor,
          notPassedRouteColor: s.notPassedRouteColor,
          trajectoryLineWeight: s.trajectoryLineWeight,
          trajectoryLineOpacity: s.trajectoryLineOpacity,
          carSpeed: s.carSpeed,
          interval: s.interval,
          showHistoryTrack: s.showHistoryTrack,
          loopPlay: s.loopPlay,
          carIconSize: s.carIconSize,
          carEmoji: s.carEmoji,
          showTooltip: s.showTooltip,
          showArrow: s.showArrow,
          offset: s.offset,
          repeat: s.repeat,
          pixelSize: s.pixelSize,
          headAngle: s.headAngle,
          arrowColor: s.arrowColor,
          weight: s.weight
        };
      } catch (e) {
        this.$message.error('加载配置失败，已恢复默认');
      }
    },
    handleSave() {
      this.saveLoading = true;
      try {
        saveElectronicMapSettings(this.form);
        this.$message.success('配置已保存');
      } catch (e) {
        this.$message.error('保存失败：' + (e && e.message ? e.message : '未知错误'));
      } finally {
        this.saveLoading = false;
      }
    },
    handleReset() {
      this.form = {
        routeColor: DEFAULTS.routeColor,
        routeWidth: DEFAULTS.routeWidth,
        routeBaseAlpha: DEFAULTS.routeBaseAlpha,
        passedRouteColor: DEFAULTS.passedRouteColor,
        notPassedRouteColor: DEFAULTS.notPassedRouteColor,
        trajectoryLineWeight: DEFAULTS.trajectoryLineWeight,
        trajectoryLineOpacity: DEFAULTS.trajectoryLineOpacity,
        carSpeed: DEFAULTS.carSpeed,
        interval: DEFAULTS.interval,
        showHistoryTrack: DEFAULTS.showHistoryTrack,
        loopPlay: DEFAULTS.loopPlay,
        carIconSize: DEFAULTS.carIconSize,
        carEmoji: DEFAULTS.carEmoji,
        showTooltip: DEFAULTS.showTooltip,
        showArrow: DEFAULTS.showArrow,
        offset: DEFAULTS.offset,
        repeat: DEFAULTS.repeat,
        pixelSize: DEFAULTS.pixelSize,
        headAngle: DEFAULTS.headAngle,
        arrowColor: DEFAULTS.arrowColor,
        weight: DEFAULTS.weight
      };
      try {
        saveElectronicMapSettings(this.form);
        this.$message.success('已恢复默认配置');
      } catch (e) {
        this.$message.error('恢复默认失败');
      }
    },
    loadAdminSettings() {
      const c = getSystemConfig();
      this.adminForm.systemTitle = c.systemTitle;
      this.adminForm.systemTitleShort = c.systemTitleShort;
      this.adminForm.platformLogo = c.platformLogo;
    },
    async loadAnnouncementConfig() {
      try {
        const res = await api.post('/system/announcement-config/query', {});
        if (res.data && res.data.success) {
          const c = res.data.data || {};
          this.adminForm.announcement = c.announcement || '';
          this.adminForm.announcementColor = c.announcementColor || 'rgba(255,140,0,1)';
          this.adminForm.announcementFontSize = Number.isFinite(c.announcementFontSize) ? c.announcementFontSize : 22;
          this.adminForm.announcementScrollSpeed = Number.isFinite(c.announcementScrollSpeed)
            ? Math.max(10, Math.min(50, c.announcementScrollSpeed))
            : 26;
          this.adminForm.announcementScroll = !!c.announcementScroll;
          this.adminForm.announcementPublished = !!c.announcementPublished;

          if (Array.isArray(c.announcementViewerRoles)) {
            this.adminForm.announcementViewerRoles = c.announcementViewerRoles;
          } else {
            // 未显式配置：默认展示给全部角色
            const allCodes = (this.roleOptions || [])
              .map(r => r && r.roleCode)
              .filter(Boolean);
            this.adminForm.announcementViewerRoles = allCodes;
          }
        }
      } catch (e) {
        // 读取失败时保持默认值，不展示错误信息
      }
    },
    async loadWatermarkConfig() {
      try {
        const res = await api.post('/system/watermark-config/query', {});
        if (res.data && res.data.success) {
          const c = res.data.data || {};
          this.adminForm.watermarkEnabled = !!c.enabled;
          this.adminForm.watermarkContentTemplate = c.contentTemplate || '{username} {ip} {date}';
          this.adminForm.watermarkFontSize = Number.isFinite(c.fontSize) ? c.fontSize : 20;
          this.adminForm.watermarkFontColor = c.fontColor || 'rgba(0,0,0,0.2)';
          this.adminForm.watermarkRotate = Number.isFinite(c.rotate) ? c.rotate : -20;
          this.adminForm.watermarkGlobalAlpha = Number.isFinite(c.globalAlpha) ? c.globalAlpha : 0.2;
          this.adminForm.watermarkWidth = Number.isFinite(c.width) ? c.width : 300;
          this.adminForm.watermarkHeight = Number.isFinite(c.height) ? c.height : 300;
          this.adminForm.watermarkLayoutType = c.layoutType || 'grid';
          this.adminForm.watermarkGridRows = Number.isFinite(c.gridRows) ? c.gridRows : 2;
          this.adminForm.watermarkGridCols = Number.isFinite(c.gridCols) ? c.gridCols : 2;
          this.adminForm.watermarkGapX = Number.isFinite(c.gapX) ? c.gapX : 20;
          this.adminForm.watermarkGapY = Number.isFinite(c.gapY) ? c.gapY : 20;
          this.adminForm.watermarkTranslateX = Number.isFinite(c.translateX) ? c.translateX : 0;
          this.adminForm.watermarkTranslateY = Number.isFinite(c.translateY) ? c.translateY : 0;
        }
      } catch (e) {
        // ignore
      }
    },
    beforeLogoUpload(file) {
      const isImage = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'].includes(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传 PNG、JPG、JPEG、GIF 格式的图片');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB');
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.adminForm.platformLogo = e.target.result;
      };
      reader.readAsDataURL(file);
      return false;
    },
    handleRestoreDefaultLogo() {
      this.adminForm.platformLogo = DEFAULT_LOGO_URL;
      saveSystemConfig(this.adminForm);
      this.$root.$emit('system-config-updated');
      this.$message.success('已恢复默认 logo');
    },
    async handleSaveAdmin() {
      this.adminSaveLoading = true;
      try {
        // 平台标题/Logo：仍由本地系统配置保存
        saveSystemConfig(this.adminForm);

        // 公告配置：写入数据库（全平台单例）
        await api.post('/system/announcement-config', {
          announcement: this.adminForm.announcement,
          announcementColor: this.adminForm.announcementColor,
          announcementFontSize: this.adminForm.announcementFontSize,
          announcementScrollSpeed: this.adminForm.announcementScrollSpeed,
          announcementScroll: this.adminForm.announcementScroll,
          announcementPublished: this.adminForm.announcementPublished,
          announcementViewerRoles: this.adminForm.announcementViewerRoles
        });

        // 公告保存完成后，保存水印配置
        await api.post('/system/watermark-config', {
          enabled: this.adminForm.watermarkEnabled,
          contentTemplate: this.adminForm.watermarkContentTemplate,
          fontSize: this.adminForm.watermarkFontSize,
          fontColor: this.adminForm.watermarkFontColor,
          rotate: this.adminForm.watermarkRotate,
          globalAlpha: this.adminForm.watermarkGlobalAlpha,
          width: this.adminForm.watermarkWidth,
          height: this.adminForm.watermarkHeight,
          layoutType: this.adminForm.watermarkLayoutType,
          gridRows: this.adminForm.watermarkGridRows,
          gridCols: this.adminForm.watermarkGridCols,
          gapX: this.adminForm.watermarkGapX,
          gapY: this.adminForm.watermarkGapY,
          translateX: this.adminForm.watermarkTranslateX,
          translateY: this.adminForm.watermarkTranslateY
        });

        this.$root.$emit('system-config-updated');
        this.$root.$emit('announcement-config-updated');
        this.$root.$emit('watermark-config-updated');
        this.$message.success('系统配置已保存');
      } catch (e) {
        this.$message.error(e.response?.data?.message || '保存失败');
      } finally {
        this.adminSaveLoading = false;
      }
    },
    async loadUserList() {
      this.userListLoading = true;
      try {
        const res = await api.post('/user/list', {
          username: this.userSearchForm.username,
          phone: this.userSearchForm.phone,
          statusCode: this.userSearchForm.statusCode,
          page: this.userCurrentPage,
          pageSize: this.userPageSize
        });
        const body = res.data;
        if (body && body.success) {
          const payload = body.data;
          this.userList = Array.isArray(payload) ? payload : (payload && payload.list) ? payload.list : [];
          this.userTotal = (payload && typeof payload.total === 'number') ? payload.total : 0;
        } else {
          this.userList = [];
          this.userTotal = 0;
        }
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载用户列表失败');
        this.userList = [];
        this.userTotal = 0;
      } finally {
        this.userListLoading = false;
      }
    },
    handleUserSearch() {
      this.userCurrentPage = 1;
      this.loadUserList();
    },
    handleUserSearchReset() {
      this.userSearchForm.username = '';
      this.userSearchForm.phone = '';
      this.userSearchForm.statusCode = '';
      this.userCurrentPage = 1;
      this.loadUserList();
    },
    handleUserSizeChange(size) {
      this.userPageSize = size;
      this.userCurrentPage = 1;
      this.loadUserList();
    },
    handleUserCurrentChange(page) {
      this.userCurrentPage = page;
      this.loadUserList();
    },
    userIndexMethod(index) {
      return (this.userCurrentPage - 1) * this.userPageSize + index + 1;
    },
    handleUserAdd() {
      this.editUserId = null;
      this.resetUserForm();
      this.loadRoleOptions();
      this.userDialogVisible = true;
    },
    handleUserEdit(row) {
      this.editUserId = row.id;
      this.userForm.nickname = row.nickname || '';
      this.userForm.phone = row.phone || '';
      this.userForm.password = '';
      this.userForm.confirmPassword = '';
      this.userForm.role = row.role || '';
      this.userForm.statusCode = row.statusCode || 'ACTIVE';
      this.loadRoleOptions();
      this.userDialogVisible = true;
    },
    resetUserForm() {
      this.userForm = {
        nickname: '',
        phone: '',
        password: '',
        confirmPassword: '',
        role: '',
        statusCode: 'ACTIVE'
      };
      this.$refs.userForm && this.$refs.userForm.resetFields();
    },
    async loadRoleOptions() {
      this.roleOptionsLoading = true;
      try {
        const res = await api.post('/role/all', {});
        if (res.data.success) {
          this.roleOptions = res.data.data || [];
        } else {
          this.roleOptions = [];
        }
      } catch (e) {
        this.roleOptions = [];
      } finally {
        this.roleOptionsLoading = false;
      }

      // 如果系统配置没有显式设置“谁可以看”，则默认全选平台全部角色。
      if (!Array.isArray(this.adminForm.announcementViewerRoles)) {
        const allCodes = (this.roleOptions || [])
          .map(r => r && r.roleCode)
          .filter(Boolean);
        this.adminForm.announcementViewerRoles = allCodes;
      }
    },
    async handleUserSave() {
      this.$refs.userForm.validate(async (valid) => {
        if (!valid) return;
        this.userSaveLoading = true;
        try {
          if (this.isUserEdit) {
            const data = {
              nickname: this.userForm.nickname,
              phone: this.userForm.phone,
              role: this.userForm.role,
              statusCode: this.userForm.statusCode
            };
            if (this.userForm.password) data.password = this.userForm.password;
            const res = await api.post(`/user/${this.editUserId}/update`, data);
            if (res.data && res.data.success) {
              this.$message.success('更新成功');
              this.userDialogVisible = false;
              this.loadUserList();
            } else {
              this.$message.error((res.data && res.data.message) || '更新失败');
            }
          } else {
            const res = await api.post('/user/add', {
              nickname: this.userForm.nickname,
              phone: this.userForm.phone,
              password: this.userForm.password,
              role: this.userForm.role,
              statusCode: this.userForm.statusCode
            });
            if (res.data && res.data.success) {
              this.$message.success('新增成功');
              this.userDialogVisible = false;
              this.loadUserList();
            } else {
              this.$message.error((res.data && res.data.message) || '新增失败');
            }
          }
        } catch (e) {
          this.$message.error(e.response?.data?.message || '操作失败');
        } finally {
          this.userSaveLoading = false;
        }
      });
    },
    handleUserDelete(row) {
      this.$confirm('确定删除该用户吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await api.post(`/user/${row.id}/remove`);
          if (res.data && res.data.success) {
            this.$message.success('删除成功');
            this.loadUserList();
          } else {
            this.$message.error((res.data && res.data.message) || '删除失败');
          }
        } catch (e) {
          this.$message.error(e.response?.data?.message || '删除失败');
        }
      }).catch(() => {});
    },
    handleLandingPageFileChange(file, fileList) {
      const raw = file && file.raw;
      const name = (file && file.name) || (raw && raw.name) || '';
      if (!/\.zip$/i.test(name)) {
        this.$message.error('只能上传 zip 文件');
        this.landingPageFileList = [];
        this.landingPageForm.materialFile = null;
        this.$refs.landingPageUpload && this.$refs.landingPageUpload.clearFiles();
        this.$refs.landingPageForm && this.$refs.landingPageForm.validateField('materialFile');
        return;
      }
      const latest = fileList && fileList.length ? fileList[fileList.length - 1] : file;
      this.landingPageFileList = latest ? [latest] : [];
      this.landingPageForm.materialFile = latest && latest.raw ? latest.raw : null;
      this.$refs.landingPageForm && this.$refs.landingPageForm.validateField('materialFile');
    },
    handleLandingPageFileRemove() {
      this.landingPageFileList = [];
      this.landingPageForm.materialFile = null;
      this.$refs.landingPageForm && this.$refs.landingPageForm.validateField('materialFile');
    },
    handleLandingPageFileExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.$refs.landingPageUpload && this.$refs.landingPageUpload.clearFiles();
      this.handleLandingPageFileChange({
        name: nextFile.name,
        raw: nextFile
      }, [{
        name: nextFile.name,
        raw: nextFile
      }]);
    },
    resetLandingPageForm() {
      this.landingPageForm = {
        terminalType: '',
        materialFile: null
      };
      this.landingPageFileList = [];
      this.$refs.landingPageUpload && this.$refs.landingPageUpload.clearFiles();
      this.$nextTick(() => {
        this.$refs.landingPageForm && this.$refs.landingPageForm.clearValidate();
      });
    },
    handleLandingPageUpload() {
      this.$refs.landingPageForm.validate(async (valid) => {
        if (!valid) return;
        await this.submitLandingPageMaterial(false);
      });
    },
    async submitLandingPageMaterial(overwrite) {
      const formData = new FormData();
      formData.append('terminalType', this.landingPageForm.terminalType);
      formData.append('overwrite', overwrite ? '1' : '0');
      formData.append('file', this.landingPageForm.materialFile);
      this.landingPageUploadLoading = true;
      try {
        const res = await api.post('/system/landing-page-material/upload', formData, {
          timeout: 10 * 60 * 1000
        });
        if (res.data && res.data.success) {
          this.$message.success('上传成功');
          this.resetLandingPageForm();
        } else {
          this.$message.error((res.data && res.data.message) || '上传失败');
        }
      } catch (e) {
        const body = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 409 && body.code === 'MATERIAL_EXISTS' && !overwrite) {
          try {
            await this.$confirm('已存在相同名称的物料', '提示', {
              confirmButtonText: '继续',
              cancelButtonText: '取消',
              type: 'warning'
            });
            await this.submitLandingPageMaterial(true);
          } catch (confirmError) {
            // 用户取消覆盖时停止本次上传
          }
          return;
        }
        this.$message.error(body.message || '上传失败');
      } finally {
        this.landingPageUploadLoading = false;
      }
    },
    getBackupFileName(disposition) {
      const fallback = `shareLearningDB-backup-${Date.now()}.zip`;
      const header = String(disposition || '');
      const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1]);
        } catch (e) {
          return utf8Match[1];
        }
      }
      const match = header.match(/filename="?([^";]+)"?/i);
      return match && match[1] ? match[1] : fallback;
    },
    async readBackupErrorMessage(error) {
      const data = error && error.response && error.response.data;
      if (data instanceof Blob) {
        try {
          const text = await data.text();
          const json = JSON.parse(text);
          return json && json.message ? json.message : '';
        } catch (e) {
          return '';
        }
      }
      return data && data.message ? data.message : '';
    },
    saveBackupByBrowserDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async handleDatabaseBackup() {
      let directoryHandle = null;
      if (window.showDirectoryPicker) {
        try {
          directoryHandle = await window.showDirectoryPicker({
            id: 'share-learning-db-backup',
            mode: 'readwrite'
          });
        } catch (e) {
          if (e && e.name === 'AbortError') return;
          this.$message.error('选择备份目录失败');
          return;
        }
      } else {
        try {
          await this.$confirm('当前浏览器不支持目录选择，将使用浏览器默认下载目录保存备份文件。', '提示', {
            type: 'warning',
            confirmButtonText: '继续',
            cancelButtonText: '取消'
          });
        } catch (e) {
          return;
        }
      }

      this.databaseBackupLoading = true;
      this.databaseBackupProgress = 8;
      this.databaseBackupStatus = '正在生成备份文件...';
      try {
        const res = await api.post('/system/database-backup/download', {}, {
          responseType: 'blob',
          timeout: 10 * 60 * 1000,
          onDownloadProgress: (event) => {
            if (event.total) {
              const percent = Math.round((event.loaded / event.total) * 80);
              this.databaseBackupProgress = Math.max(8, Math.min(88, percent));
              this.databaseBackupStatus = '正在下载备份文件...';
            } else if (this.databaseBackupProgress < 45) {
              this.databaseBackupProgress = 45;
            }
          }
        });
        const filename = this.getBackupFileName(res.headers && res.headers['content-disposition']);
        const blob = res.data;
        this.databaseBackupProgress = Math.max(this.databaseBackupProgress, 90);
        this.databaseBackupStatus = '正在写入本地目录...';

        if (directoryHandle) {
          const fileHandle = await directoryHandle.getFileHandle(filename, { create: true });
          const writable = await fileHandle.createWritable();
          await writable.write(blob);
          await writable.close();
        } else {
          this.saveBackupByBrowserDownload(blob, filename);
        }

        this.databaseBackupProgress = 100;
        this.databaseBackupStatus = '备份完成';
        this.databaseBackupLastFileName = filename;
        this.$message.success('数据库备份已保存');
      } catch (e) {
        const message = await this.readBackupErrorMessage(e);
        this.$message.error(message || '数据库备份失败');
      } finally {
        setTimeout(() => {
          this.databaseBackupLoading = false;
          this.databaseBackupStatus = '';
          this.databaseBackupProgress = 0;
        }, 500);
      }
    },
    roleLabel(role) {
      if (!role) return '-';
      const r = this.roleOptions.find(x => x.roleCode === role);
      if (r) return r.roleName;
      const legacy = { admin: '管理员', manager: '运营', user: '普通用户' };
      return legacy[role] || role;
    }
  }
};
</script>

<style scoped>
.system-settings-page {
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
  height: 100%;
}

.settings-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.settings-card >>> .el-card__body {
  flex: 1;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.settings-card >>> .el-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.settings-card >>> .el-tabs__content {
  flex: 1;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.settings-card >>> .el-tab-pane {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
}

.settings-card >>> .el-tabs .scheduled-task-manage-pane {
  flex:1;
}

.electronic-map-config {
  padding: 0 24px 24px;
  max-width: 600px;
}

.form-actions {
  margin-top: 16px;
}

.form-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.color-value {
  margin-left: 12px;
  font-size: 12px;
  color: #606266;
  word-break: break-all;
}

.admin-tools-config,
.alert-config-pane,
.database-backup-pane,
.about-pane {
  padding: 24px;
}

.admin-tools-section-title {
  margin: 12px 0 8px;
  padding-top: 10px;
  border-top: 1px solid rgba(60, 60, 67, 0.12);
  font-size: 14px;
  font-weight: 600;
  color: #409EFF;
}

.admin-tools-section-title--first {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.landing-page-manage-pane {
  padding: 20px 0;
}

.landing-page-form {
  max-width: 760px;
}

.database-backup-form {
  max-width: 760px;
}

.database-backup-path {
  width: 420px;
  max-width: 100%;
}

.database-backup-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.database-backup-file {
  color: #606266;
  font-size: 13px;
  word-break: break-all;
}

.database-backup-progress {
  width: 420px;
  max-width: 100%;
}

.database-backup-status {
  display: inline-block;
  margin-top: 8px;
  color: #909399;
  font-size: 13px;
}

.announcement-font-size-input {
  display: flex;
  align-items: center;
}

.announcement-font-size-unit {
  margin-left: 8px;
  color: #606266;
  font-size: 14px;
}

.announcement-scroll-speed-input {
  display: flex;
  align-items: center;
}

.announcement-scroll-speed-unit {
  margin-left: 8px;
  color: #606266;
  font-size: 14px;
}

.watermark-font-size-input {
  display: flex;
  align-items: center;
}

.watermark-unit {
  margin-left: 8px;
  color: #606266;
  font-size: 14px;
}

.user-manage-pane {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.role-manage-pane {
  padding: 24px;
  flex: 1;
  min-height: 0;
  display: flex;
}

.role-manage-pane >>> .role-manage {
  flex: 1;
  min-height: 0;
  padding-bottom: 0;
}

.user-search-area {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.user-search-area .search-form {
  flex: 1;
}

.user-search-area .btn-group {
  flex-shrink: 0;
}

.logo-upload-wrap {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.logo-preview {
  width: 80px;
  height: 80px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.placeholder-tip {
  color: #909399;
  font-size: 14px;
}

.version-text {
  font-size: 16px;
  color: #303133;
}

.version-text strong {
  color: #409EFF;
}

.danger-btn {
  color: #f56c6c;
}

/* 用户管理弹窗 */
.user-form .user-form-input {
  width: 350px;
}

.user-dialog >>> .el-dialog__body {
  overflow: hidden;
  padding: 20px 20px 10px;
}

.user-form .password-strength {
  margin-top: -10px;
  margin-bottom: 18px;
  margin-left: 100px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.user-form .password-strength .strength-label {
  color: #909399;
  margin-right: 8px;
}

.user-form .password-strength .el-rate {
  height: 20px;
}

.user-form .password-strength .el-rate__icon {
  font-size: 18px;
}
</style>
